module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hotsite-dcom', [_c('div', {
    staticClass: "conteudo",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('bloco', {
    staticClass: "-nomargin -softpadding"
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Sobre a DCOM")]), _c('small', {
    staticClass: "more"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'DCOMSobre'
      }
    }
  }, [_vm._v("Ver tudo")])], 1)], 1), (_vm.sobre) ? _c('div', {
    staticClass: "texto dcom-sobre-inicial",
    attrs: {
      "slot": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.sobre)
    },
    slot: "content"
  }) : _c('loading', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  })], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('bloco', {
    staticClass: "-nomargin -softpadding"
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-upper"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o fa-lg"
  }, [_vm._v("  ")]), _vm._v("Destaque")])], 1), (_vm.destaque) ? _c('div', {
    staticClass: "texto dcom-sobre-inicial",
    attrs: {
      "slot": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.destaque)
    },
    slot: "content"
  }) : _c('loading', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  })], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('bloco', {
    staticClass: "-nomargin -softpadding"
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-upper"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o fa-lg"
  }, [_vm._v("  ")]), _vm._v("Orientações e Manuais")])], 1), (_vm.orientacoes) ? _c('div', {
    staticClass: "texto dcom-sobre-inicial",
    attrs: {
      "slot": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.orientacoes)
    },
    slot: "content"
  }) : _c('loading', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  })], 1)], 1)]), _c('div', {
    staticClass: "row faixa margin"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('bloco', {
    staticClass: "-nomargin -softpadding"
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-upper"
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap fa-lg"
  }, [_vm._v("  ")]), _vm._v("Editais")]), (_vm.editaisE.length > 0) ? _c('small', {
    staticClass: "more"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'DCOMEditais'
      }
    }
  }, [_vm._v("Ver tudo")])], 1) : _vm._e()], 1), (_vm.loading) ? _c('loading', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }) : _vm._e(), (_vm.editaisE.length > 0) ? _c('div', {
    staticClass: "texto dcom-sobre-inicial",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "lista dcom-editais-inicial"
  }, [_c('div', {
    staticClass: "esq"
  }, _vm._l((_vm.editaisE), function(edital) {
    return _c('li', {
      staticClass: "item"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": edital.link,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v(_vm._s(edital.nome))])])
  }), 0), _c('div', {
    staticClass: "dir"
  }, _vm._l((_vm.editaisD), function(edital) {
    return _c('li', {
      staticClass: "item"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": edital.link,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v(_vm._s(edital.nome))])])
  }), 0)])]) : (_vm.editaisE.length == 0 && _vm.loading == false) ? _c('mensagem', {
    staticClass: "-warn",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v("Nenhum edital foi encontrado no momento            ")])]) : _vm._e()], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b910b68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/dcom/Index.vue
// module id = 475
// module chunks = 0